import { createSlice } from '@reduxjs/toolkit';

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState: {
    message: '',
    severity: 'info',
    open: false,
  },
  reducers: {
    showNotification(state, action) {
      state.message = action.payload.message;
      state.severity = action.payload.severity || 'info';
      state.open = true;
    },
    closeSnackbar(state) {
      state.open = false;
    },
  },
});

export const { showNotification, closeSnackbar } = snackbarSlice.actions;
export const snackbarReducer = snackbarSlice.reducer;

export default snackbarSlice.reducer;
